import role from '../ui/role';
import navigator from '../ui/navigator';
import { INSPECTION_LISTING, PLATFORM_ADMIN_HOME, } from '../../constants/routeDestinations';
export const sendToHome = () => {
    const user = window.config.session_user;
    if (!user) {
        return;
    }
    if (role.isPlatformAdmin(user)) {
        navigator.push(PLATFORM_ADMIN_HOME);
        return;
    }
    navigator.push(INSPECTION_LISTING);
};
